export default function accountReducer(account, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "resetPassword":
      return { ...account, password: action.value, confirmPassword: action.value };

    default:
      return { ...account, [action.type]: action.value };
  }
}
